// Centralised brand assets (uploaded by client — FINAL)
export const BRAND = {
  // Transparent wordmark — use in header / footer
  wordmark:
    "https://customer-assets.emergentagent.com/job_pro-cleaning-20/artifacts/8fr30zeb_clean%20me%20logo%20png.png",
  fullLogoMascot:
    "https://customer-assets.emergentagent.com/job_pro-cleaning-20/artifacts/meqky5lm_ChatGPT%20Image%20Apr%2021%2C%202026%2C%2003_32_12%20PM.png",
  // Mascot — transparent PNG; safe on any background.
  mascot:
    "https://customer-assets.emergentagent.com/job_pro-cleaning-20/artifacts/w2ncx7vc_ChatGPT%20Image%20Apr%2021%2C%202026%2C%2003_36_36%20PM.png",
  // Transparent favicon
  favicon:
    "https://customer-assets.emergentagent.com/job_pro-cleaning-20/artifacts/eps8lxvy_clean%20me%20favicon%20png.png",
};

export const PHOTOS = {
  office: "https://images.pexels.com/photos/8682781/pexels-photo-8682781.jpeg",
  gym: "https://images.unsplash.com/photo-1761971975047-6426232852ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGd5bSUyMGludGVyaW9yfGVufDB8fHx8MTc3NzM4MzM2Nnww&ixlib=rb-4.1.0&q=85",
  retail:
    "https://images.pexels.com/photos/13068378/pexels-photo-13068378.jpeg",
  cleaningPro:
    "https://images.pexels.com/photos/34516670/pexels-photo-34516670.jpeg",
};

export const CONTACT = {
  phone: "085 8828 656",
  phoneTel: "+353858828656",
  email: "conor@cleanme.ie",
  location: "Cork, Ireland",
};
